import {
  IDeletedConfigurationDetailsItem,
  IDeletedConfigurationListItem,
  IDeletedConfigurationPageRequestParams,
} from "api/entities/deleted-config";
import { DataService } from "./data-service";
import { IPage } from "api/entities/page";

class DeletedConfigService extends DataService {
  constructor() {
    super("archive", 2);
  }

  getPage(
    requestParams: IDeletedConfigurationPageRequestParams,
  ): Promise<IPage<IDeletedConfigurationListItem>> {
    return this.api.get<IPage<IDeletedConfigurationListItem>>(
      null,
      requestParams,
    );
  }

  get(archiveId: string): Promise<IDeletedConfigurationDetailsItem> {
    return this.api.get<IDeletedConfigurationDetailsItem>(archiveId);
  }

  download(archiveId: string): Promise<ArrayBuffer> {
    return this.api.get<ArrayBuffer>(
      `download/${archiveId}`,
    );
  }
}

export const deletedConfigService = new DeletedConfigService();
